(function () {
    'use strict';

    angular
        .module("skillsApp")
        .controller("ErrorController", ErrorController);

    function ErrorController(config, $state, $stateParams) {
        var vm = this;

        vm.error = $stateParams.error;
        vm.date = new Date().toLocaleString();
    }

})();
